import ApiService from '@/services/api';
const API = new ApiService();
import _ from 'lodash';

export const state = {
  listings: [],
  landmarks: [],
  tarpaulins: [],
  banners: [],
  windowBoxes: [],
  hangers: [],
  collateralPlacements: [],
  rentHistoryList:[],
  listinTotalRows: 0,
  carts:[],
  favoriteListing: [],
  favoritelistinTotalRows: 0,
  businessDetails: null,
  businessHistory: null
}

export const mutations = {
  SET_LISTINGS(state, listings) {
    state.listings = listings;
  },
  SET_FAVORITE_LISTINGS(state, listings) {
    state.favoriteListing = listings;
  },
  SET_LANDMARKS(state, landmarks) {
    state.landmarks = landmarks;
  },
  SET_COLLATERAL_PLACEMENTS(state, collateralPlacements) {
    state.collateralPlacements = collateralPlacements;
  },
  SET_TARPAULIN_SIZES(state, tarpaulins) {
    state.tarpaulins = tarpaulins;
  },
  SET_BANNER_SIZES(state, banners) {
    state.banners = banners;
  },
  SET_WINDOW_BOX_SIZES(state, windowBoxes) {
    state.windowBoxes = windowBoxes;
  },
  SET_HANGER_SIZES(state, hangers) {
    state.hangers = hangers;
  },
  UPDATE_TOTAL_LISTING_PAGE(state, pageInfo){
    state.listinTotalRows = pageInfo;
  },
  UPDATE_CARTS(state, items){
    state.carts = items;
  },
  UPDATE_TOTAL_FAVORITE_LISTING_PAGE(state, pageInfo){
    state.favoritelistinTotalRows = pageInfo;
  },
  UPDATE_BUSINESS_DETAILS(state, items){
    state.businessDetails = items;
  },
  UPDATE_BUSINESS_HISTORY(state, items){
    state.businessHistory = items;
  },
}

export const getters = {
}

export const actions = {
  fetchListings({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/listing/list', params)
        .then(res => {
          commit('SET_LISTINGS', res.message);
          commit('UPDATE_CARTS', res.message.carts);
          resolve(_.cloneDeep(res.message))
        })
        .catch(err => reject(err));
    });
  },
  fetchLandmarks({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('landmark', addresses)
        .then(res => {
          commit('SET_LANDMARKS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchAllLandmarks({ commit }) {
    return new Promise((resolve, reject) => {
      fetchReferences('all_landmark', null, true)
        .then(res => {
          commit('SET_LANDMARKS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchTarpaulinSizes({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('tarpaulin', addresses)
        .then(res => {
          commit('SET_TARPAULIN_SIZES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchBannerSizes({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('banner', addresses)
        .then(res => {
          commit('SET_BANNER_SIZES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchWindowBoxSizes({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('window box', addresses)
        .then(res => {
          commit('SET_WINDOW_BOX_SIZES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchHangerSizes({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('hanger', addresses)
        .then(res => {
          commit('SET_HANGER_SIZES', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchPlacements({ commit }, addresses) {
    return new Promise((resolve, reject) => {
      fetchReferences('collateral_placement', addresses)
        .then(res => {
          commit('SET_COLLATERAL_PLACEMENTS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchPublicListings({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/public/listing/list', params)
        .then(res => {
          commit('SET_LISTINGS', res.message.rows);
          commit('UPDATE_TOTAL_LISTING_PAGE', res.message.pageInfo.total);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchPublicLandmarks({ commit }) {
    return new Promise((resolve, reject) => {
      fetchPublicReferences('landmark')
        .then(res => {
          commit('SET_LANDMARKS', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchPublicStoreDetails({ commit }, params) {
    commit('UPDATE_BUSINESS_DETAILS', null);//remove the previous loaded data
    return new Promise((resolve, reject) => {
      API.post('/listing/store-details', params)
        .then(res => {
          commit('UPDATE_BUSINESS_DETAILS', res.message.storeDetails);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  fetchStoreHistory({ commit }, params) {
    commit('UPDATE_BUSINESS_HISTORY', null);//remove the previous loaded data
    return new Promise((resolve, reject) => {
      API.post('/listing/store-history', params)
        .then(res => {
          commit('UPDATE_BUSINESS_HISTORY', res.message);
          resolve(res.message)
        })
        .catch(err => reject(err));
    });
  },
  updateCarts({ commit }, params) {
    return commit('UPDATE_CARTS', params);
  },
  fetchFavoriteListings({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/listing/favorites', params)
        .then(res => {
          commit('SET_FAVORITE_LISTINGS', res.message.rows);
          commit('UPDATE_TOTAL_FAVORITE_LISTING_PAGE', res.message.pageInfo.total);
          resolve(res.message);
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  addToFavoriteListings({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/listing/add-favorites', params)
        .then(res => {
          resolve(res.message);
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  removeToFavoriteListings({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/listing/remove-favorites', params)
        .then(res => {
          resolve(res.message);
        })
        .catch(err => reject(err));
    });
  },
}


const fetchReferences = async function (filterType, addresses, isPublic = false) {
  var url = '';
  if(isPublic){
    url = '/public/listing/filters';
  } else {
    url = '/listing/filters';
  } 
  return API.post(url, { filterType: filterType, addresses: addresses });
}
const fetchPublicReferences = async function (filterType) {
  return API.post('/public/listing/filters', { filterType: filterType });
}